import { Badge, Box, Flex, Text } from '@mantine/core';
import { KYCWorkflowStatus } from '@dealstack/shared/lib/generated';
import { getKycStatusColor } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/utils/statusStyling.helper.ts';
import {
	getDocumentStatusLabel,
	getKycStatusDotColor,
	getKycStatusLabel,
	KYCDocumentStatus,
} from './utils.ts';

interface DocumentStatusBadgeProps {
	status: KYCDocumentStatus;
}

export const DocumentStatusBadge = ({ status }: DocumentStatusBadgeProps) => (
	<Badge size="xs" variant="outline" color={getKycStatusColor(status)}>
		{getDocumentStatusLabel(status)}
	</Badge>
);

interface KycOverallStatusBadgeProps {
	status: KYCWorkflowStatus;
}

export const KycOverallStatusBadge = ({ status }: KycOverallStatusBadgeProps) => {
	const color = getKycStatusDotColor(status);
	return (
		<Flex align="center" gap={6}>
			<Box
				w={6}
				h={6}
				style={{
					borderRadius: '50%',
					backgroundColor: color,
					flexShrink: 0,
				}}
			/>
			<Text size="sm" c={color}>
				{getKycStatusLabel(status)}
			</Text>
		</Flex>
	);
};
